module.exports = __webpack_public_path__ + "static/media/weldon.100d1142.png";